/** Shared cursor-list query/response shapes (DynamoDB GSI / ExclusiveStartKey). */

export type CursorListParams = {
  limit?: number;
  cursor?: string;
};

export type CursorListMeta = {
  hasMore: boolean;
  nextCursor?: string;
  limit?: number;
};

export type OffsetListMeta = {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
};

export function buildListQuery(
  params?: Record<string, string | number | boolean | undefined | null>,
): Record<string, string | number | boolean | undefined> {
  if (!params) return {};
  const out: Record<string, string | number | boolean | undefined> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    out[key] = value;
  }
  return out;
}
